export default __webpack_public_path__ + "static/media/cabinet1-before-1024w.6ddedc04.avif";